import React, { useState, useEffect, Fragment, useContext } from "react";
import Typography from "@material-ui/core/Typography";
import { Grid, Icon, IconButton } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import MaterialTable from "material-table";
import LinearProgress from "@material-ui/core/LinearProgress";
import { Button, Tooltip, Hidden } from "@material-ui/core";
import { PictureAsPdf } from "@material-ui/icons";

/**Importar metodo Get */
import MethodGet, { MethodDelete } from "../../Config/Services";
/**importar spinner */
import CashOutsContext from "../../Reducers/CashOuts/CashOutsContext";
import LayoutDashboard from "../../Components/Layout/LayoutDashboard";
import clienteAxios from "../../Config/Axios";
import Moment from "moment";
import Swal from "sweetalert2";
import fileDownload from "js-file-download";
import { MethodPost } from "../../Config/Services";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

export default function CashMovements(props) {
  const { id } = props.match.params;

  const [fechaInicio, GuardarFechaInicio] = useState("");
  const [fechaFin, GuardarFechaFin] = useState("");
  const [selectedDateStart, handleDateChangeStart] = useState(new Date());
  const [selectedDateEnd, handleDateChangeEnd] = useState(new Date());
  const [boton, saveBoton] = useState(false);
  const [mostrar, setShowData] = useState(true);
  const [accountSt, saveAccountSt] = useState([]);
  const [movements, saveMovements] = useState([]);
  /**Extraer las escuelas del state inicial */

  const cambiarFechaInicio = (date) => {
    var fecha = Moment(date).format("DD-MM-YYYY");
    GuardarFechaInicio(fecha);
    handleDateChangeStart(date);
  };
  const cambiarFechaFin = (date) => {
    var fecha = Moment(date).format("DD-MM-YYYY");
    GuardarFechaFin(fecha);
    handleDateChangeEnd(date);
  };
  const data = {
    start_date: fechaInicio,
    end_date: fechaFin,
  };
  const [gmovenetsday, saveMovementday] = useState([]);

  const [gmovenets, saveMovement] = useState([]);
  const handleClearData = () => {
    setShowData(false);
  };
  const [error, guardarError] = useState(true);
  useEffect(() => {
    const getmovement = async () => {
      await clienteAxios
        .get(`schoolUtility/${id}`)
        .then((res) => {
          saveMovement(res.data);
        })
        .catch((error) => {
          console.log(error);
        });

      if (props.course) {
        guardarError(false);
      }
    };
    getmovement();
  }, []);

  const GenerarReporte = (e) => {
    //Trae los movimientos con los filtrosde fecha
    e.preventDefault();
    saveBoton(true);
    setShowData(true);
    const data = {
      start_date: fechaInicio,
      end_date: fechaFin,
    };
    let timerInterval;
    Swal.fire({
      title: "Generando",
      html: "El reporte se está generando",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      willClose: () => {
        clearInterval(timerInterval);
      },
    })
    clienteAxios
      .post(`/accountstate/${id}`, data, { responseType: "blob" })
      .then((response) => {
        fileDownload(response.data, "EstadoDeCuenta.pdf");
        guardarError(false);
      })
      .catch((error) => {
        if (error.response.status === 409) {
          Swal.fire({
            icon: "error",
            title: "Algo sucedio",
            text: "No se cuenta con suficiente información para generar el reporte",
          });
        } else if (error.response.status === 422) {
          guardarError(true);
        }
      });
    MethodPost(`cash_Movements_day/${id}`, data)
      .then((res) => {
        saveAccountSt(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
      MethodPost(`cashmovemnts/${id}`, data)
      .then((res) => {
        saveMovements(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const [gbranch, saveBranch] = useState([]);
  useEffect(() => {
    const getotals = async () => {
      await clienteAxios
        .get(`schools/${id}`)
        .then((res) => {
          saveBranch(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
      if (props.course) {
        guardarError(false);
      }
    };
    getotals();
  }, []);

  return (
    <LayoutDashboard>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        style={{
          background: "linear-gradient(50deg, #3f51b5 33%, indigo 100%)",
          color: "white",
          marginTop: 90,
          borderRadius: 15,
          marginLeft: 10,
          marginRight: 10,

          paddingLeft: 100,
          paddingRight: 100,
        }}
      >
        <Typography align="center" component="h1" variant="h4">
          Movimientos de Caja De La Escuela {gbranch.name}
        </Typography>
      </Grid>
      <Grid style={{ marginLeft: 20, marginRight: 20, marginTop: 20 }}>
        <Grid container>
          <Grid xs={12} md={3} style={{ padding: 10 }}>
            <Box style={{ backgroundColor: "#303F9F" }} borderRadius={20}>
              <Typography
                align="center"
                variant="h5"
                style={{ color: "white", fontWeight: "bold", marginBottom: 5 }}
              >
                Saldo Anterior
              </Typography>
              <Grid container>
                <Grid md={12} xs={12}>
                  <Typography
                    align="center"
                    variant="h3"
                    style={{ color: "white", marginTop: 15, marginBottom: 15 }}
                  >
                    {Object.keys(gmovenets).length != 0 ? (
                      new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                        minimumFractionDigits: 0,
                      }).format(gmovenets.last_money_day)
                    ) : (
                      <LinearProgress />
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid xs={12} md={3} style={{ padding: 10 }}>
            <Box style={{ backgroundColor: "#303F9F" }} borderRadius={20}>
              <Typography
                align="center"
                variant="h5"
                style={{ color: "white", fontWeight: "bold", marginBottom: 5 }}
              >
                Ventas Actuales
              </Typography>
              <Grid container>
                <Grid md={12} xs={12}>
                  <Typography
                    align="center"
                    variant="h3"
                    style={{ color: "white", marginTop: 15, marginBottom: 15 }}
                  >
                    {Object.keys(gmovenets).length != 0 ? (
                      new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                        minimumFractionDigits: 0,
                      }).format(gmovenets.total_money_today)
                    ) : (
                      <LinearProgress />
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid xs={12} md={3} style={{ padding: 10 }}>
            <Box style={{ backgroundColor: "#303F9F" }} borderRadius={20}>
              <Typography
                align="center"
                variant="h5"
                style={{ color: "white", fontWeight: "bold", marginBottom: 5 }}
              >
                Salidas/Gastos Actuales
              </Typography>
              <Grid container>
                <Grid md={12} xs={12}>
                  <Typography
                    align="center"
                    variant="h3"
                    style={{ color: "white", marginTop: 15, marginBottom: 15 }}
                  >
                    {Object.keys(gmovenets).length != 0 ? (
                      new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                        minimumFractionDigits: 0,
                      }).format(gmovenets.salida_gasto)
                    ) : (
                      <LinearProgress />
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid xs={12} md={3} style={{ padding: 10 }}>
            <Box style={{ backgroundColor: "#303F9F" }} borderRadius={20}>
              <Typography
                align="center"
                variant="h5"
                style={{ color: "white", fontWeight: "bold", marginBottom: 5 }}
              >
                Saldo Actual
              </Typography>
              <Grid container>
                <Grid md={12} xs={12}>
                  <Typography
                    align="center"
                    variant="h3"
                    style={{ color: "white", marginTop: 15, marginBottom: 15 }}
                  >
                    {Object.keys(gmovenets).length != 0 ? (
                      new Intl.NumberFormat("es-MX", {
                        style: "currency",
                        currency: "MXN",
                        minimumFractionDigits: 0,
                      }).format(gmovenets.saldo_actual)
                    ) : (
                      <LinearProgress />
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          style={{
            background: "linear-gradient(50deg, #3f51b5 33%, indigo 100%)",
            color: "white",
            marginTop: 10,
            borderRadius: 15,
            marginLeft: 10,
            marginRight: 10,

            paddingLeft: 100,
            paddingRight: 100,
          }}
        >
          <Typography align="center" component="h1" variant="h4">
            Movimientos de Caja por Fecha
          </Typography>
        </Grid>
        <Grid
        style={{
          marginTop: 10,
          borderRadius: 10,
          marginLeft: 10,
          marginRight: 10,
          paddingLeft: 7,
          paddingRight: 7,
        }}
      >
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <form onSubmit={GenerarReporte} noValidate>
            <Grid
              container
              spacing={2}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Grid item xs={12} sm={5}>
                <KeyboardDatePicker
                  autoOk
                  fullWidth
                  inputVariant="outlined"
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  label="Fecha Inicio"
                  disableFuture
                  value={selectedDateStart}
                  onChange={cambiarFechaInicio}
                  InputAdornmentProps={{ position: "start" }}
                />
                {!fechaInicio ? (
                  <p style={{ color: "red" }}>
                    La Fecha inicial aún no ha sido seleccionada
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={5}>
                <KeyboardDatePicker
                  autoOk
                  fullWidth
                  inputVariant="outlined"
                  variant="inline"
                  format="dd/MM/yyyy"
                  margin="normal"
                  disableFuture
                  label="Fecha Fin"
                  value={selectedDateEnd}
                  onChange={cambiarFechaFin}
                  InputAdornmentProps={{ position: "start" }}
                />
                {!fechaFin ? (
                  <p style={{ color: "red" }}>
                    La Fecha final aún no ha sido seleccionada
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={1} style={{ marginTop: "22px" }}>
                <Tooltip title="Generar Reporte" aria-label="Generar Reporte">
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    color="secondary"
                    style={{ backgroundColor: "#3F51B5" }}
                  >
                    Reporte
                    <Tooltip
                      title="Generar Reporte"
                      aria-label="Generar Reporte"
                    >
                      <PictureAsPdf style={{ color: "rgb(250, 250, 250)" }} />
                    </Tooltip>
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item xs={12} sm={1} style={{ marginTop: "22px" }}>
                <Tooltip title="Limpiar" aria-label="Limpiar">
                  <Button
                    fullWidth
                    variant="contained"
                    color="secondary"
                    style={{ backgroundColor: "#4B0183" }}
                    onClick={handleClearData}
                  >
                    Limpiar
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </form>
        </MuiPickersUtilsProvider>
        {/* Resúmen de movimientos ---se deben mostrar solo cuando se haya consultado la fecha--- */}
        {boton && mostrar === true ? (
          <Grid
            container
            spacing={2}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs="12">
              <Typography align="left" variant="h5">
                Resúmen de movimientos durante el periodo seleccionado
              </Typography>
            </Grid>

            <Grid
              container
              style={{
                marginLeft: "20px",
                marginBottom: "30px",
                marginTop: "20px",
              }}
            >
              <Grid item xs="6">
                <Typography
                  align="left"
                  variant="h6"
                  style={{ fontSize: "20px" }}
                >
                  Saldo inicial = $ {accountSt.initialBalance}
                </Typography>
              </Grid>
              <Grid item xs="6">
                <Typography
                  align="left"
                  variant="h6"
                  style={{ fontSize: "20px" }}
                >
                  Saldo final = $ {accountSt.finalBalance}
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              style={{ marginLeft: "20px", marginBottom: "10px" }}
            >
              <Grid item xs="6">
                <Grid item xs="12" style={{ marginLeft: "40px" }}>
                  <Typography align="left" style={{ fontSize: "18px" }}>
                    Dinero entrante = (+) ${accountSt.totalsales}
                  </Typography>
                </Grid>
                <Grid item xs="12" style={{ marginLeft: "60px" }}>
                  <Typography align="left">
                    Ventas = (+) ${accountSt.totalsales}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs="6">
                <Grid item xs="12">
                  <Typography align="left" style={{ fontSize: "18px" }}>
                    Dinero saliente = (-) ${accountSt.outgoings}
                  </Typography>
                </Grid>
                <Grid item xs="12" style={{ marginLeft: "60px" }}>
                  <Typography align="left">
                    Gastos = (-) ${accountSt.totalexpenses}
                  </Typography>
                </Grid>
                <Grid item xs="12" style={{ marginLeft: "60px" }}>
                  <Typography align="left">
                    Salidas de caja = (-) ${accountSt.totalcashouts}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : null}
      </Grid>
        <Grid style={{ marginTop: 10 }}>
          <MaterialTable
            title=""
            columns={[
              {
                title: "Fecha de Movimiento",
                field: "created_at",
                type: "date",
              },
              {
                title: "Dinero Anterior",
                field: "previous_balance",
                render: (rowData) =>
                  new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    minimumFractionDigits: 0,
                  }).format(rowData.previous_balance),
              },
              {
                title: "Tipo de Movimiento",
                field: "sale_id",
                field: "branch_office_id",
                field: "id_expense",
                field: "inscription_id",
                render: (rowData) => {
                  return (
                    <Fragment>
                      {rowData.id_expense != null ? (
                        <p
                          style={{
                            color: "white",
                            background: "red",
                            whiteSpace: "nowrap",
                            padding: "4px",
                          }}
                          align="center"
                        >
                          Gastos
                        </p>
                      ) : rowData.id_cash_out != null ? (
                        <p
                          style={{
                            color: "white",
                            background: "#ffc400",
                            whiteSpace: "nowrap",
                            padding: "4px",
                          }}
                          align="center"
                        >
                          Salidas de Dinero
                        </p>
                      ) : rowData.sale_id != null ? (
                        <p
                          style={{
                            color: "white",
                            background: "#43a047",
                            whiteSpace: "nowrap",
                            padding: "4px",
                          }}
                          align="center"
                        >
                          Venta
                        </p>
                      ) : rowData.inscription_id != null ? (
                        <p
                          style={{
                            color: "white",
                            background: "#43a047",
                            whiteSpace: "nowrap",
                            padding: "4px",
                          }}
                          align="center"
                        >
                          Inscripcion
                        </p>
                      ) : null}
                    </Fragment>
                  );
                },
              },
              {
                title: "Diferencia",
                render: (rowData) =>
                  new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    minimumFractionDigits: 0,
                  }).format(rowData.current_balance - rowData.previous_balance),
              },
              {
                title: "Dinero Posterior",
                field: "current_balance",
                render: (rowData) =>
                  new Intl.NumberFormat("es-MX", {
                    style: "currency",
                    currency: "MXN",
                    minimumFractionDigits: 0,
                  }).format(rowData.current_balance),
              },
            ]}
            data={movements}
            options={{
              headerStyle: {
                backgroundColor: "none",
                color: "#000",
                fontSize: "16px",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
              },

              actionsColumnIndex: -1,
            }}
            localization={{
              pagination: {
                labelDisplayedRows: "{from} - {to} de {count}",
                labelRowsSelect: "Columnas",
                firstTooltip: "Primera Pagina",
                previousTooltip: "Anterior",
                nextTooltip: "Siguiente",
                lastTooltip: "Ultima Página",
              },
              toolbar: {
                searchTooltip: "Buscar",
                searchPlaceholder: "Buscar",
              },
              header: {
                actions: "Opciones",
              },
              body: {
                emptyDataSourceMessage: "No Hay Stock de productos que Mostrar",
                filterRow: {
                  filterTooltip: "Buscar",
                },
              },
            }}
          />
        </Grid>
      </Grid>
    </LayoutDashboard>
  );
}
